/* eslint-disable no-debugger */
import { Fragment } from 'react';

import useClubRegistrationMissionStatementBudget from './UseClubRegistrationMissionStatementBudget';

import ValidationPopUpModal from '../components/ValidationPopUpModal';

import ClubRegistrationConstants from '../utils/ClubRegistrationConstants';

import LeftNav from '@usas/ui-web/components/leftNav/LeftNav';
import Headings from '@usas/ui-web/components/headings/Headings';
import PrimaryButton from '@usas/ui-web/components/buttons/PrimaryButton';
import SecondaryButton from '@usas/ui-web/components/buttons/SecondaryButton';
import PopUpModal from '@usas/ui-web/components/dialogs/PopUpModal';

import global from '@usas/ui-web/components/GlobalStyle.module.css';
import Constants from '@usas/ui-web/utils/Constants';

const VISION = 'vision';

// const MISSION_STATEMENT = 'Mission Statement';
// const MISSION_STATEMENT_TYPE = 'missionStatement';

const BUDGET_OR_BUSINESS_PLAN_TITLE = 'First Year Budget';
const BUDGET_OR_BUSINESS_PLAN = 'First Year Budget or Business Plan';
const BUDGET_OR_BUSINESS_PLAN_TYPE = 'budget';

const STRATEGIC = 'strategic';
const STRATEGIC_PLAN = 'Strategic Plan';
const STRATEGIC_PLAN_TYPE = 'strategicPlan';

// const MARKETING = 'marketing';
// const MARKETING_DESCRIPTION = 'Marketing Description';
// const MARKETING_DESCRIPTION_TYPE = 'marketingDescription';

const HEAD_COACH_RESUME = 'Head Coach Resume';
const HEAD_COACH_RESUME_TYPE = 'headCoachResume';

const OWNER_BOARD_EXPERIENCE_RESUME_TITLE = 'Key Leader Form or Resume';
const OWNER_BOARD_EXPERIENCE_RESUME = 'Owner Board Experience Resume';
const OWNER_BOARD_EXPERIENCE_RESUME_TYPE = 'ownerBoardExperienceResume';

const HANDBOOK_TITLE = 'Team Handbook File';
const HANDBOOK_FILE = 'Handbook File';
const HANDBOOK_FILE_TYPE = 'handbook';

const ClubRegistrationMissionStatementBudget = () => {
  const {
    onDownloadTemplateClicked,
    onDownloadUploadedFile,
    clubRegistrationNavState,
    clubRegistrationState,
    modalState,
    removeFileModalState,
    state,
    fileState,
    usasClubFileUploadState,
    onUploadDocumentClicked,
    onOpenRemoveFileModalClicked,
    onRemoveFileModalCanceled,
    onModalContinue,
    onModalCanceled,
    onContinueClicked,
    onSaveAndExitClicked,
    onBackClicked,
    onRemoveDocumentClicked
  } = useClubRegistrationMissionStatementBudget();

  return (
    <LeftNav title={ClubRegistrationConstants.LEFT_NAV_TITLE} state={clubRegistrationNavState} validateBeforeRedirect={false}>
      <div className="row">
        <div className="col-xs-12">
          <Headings.H3>Team Uploads</Headings.H3>
        </div>
      </div>
      <div className="row usas-extra-top-margin">
        <div className="col-xs-12" style={{ color: '#202020', fontSize: '20px' }}>
          <p>Please ensure the following files are uploaded with your new club application.</p>
        </div>
      </div>
      <div className="row usas-extra-bottom-margin">
        <div className="col-xs-12" style={{ fontSize: '25px' }}>
          <p><a href="https://www.usaswimming.org/coaches-leaders/team-leaders/start-a-new-club" target="_blank" rel="noreferrer">Information on starting a new club</a></p>
        </div>
      </div>
      <div className="row usas-extra-top-margin">
        <div className="col-xs-12">
          <Headings.H6>{STRATEGIC_PLAN}</Headings.H6>
        </div>
      </div>
      {clubRegistrationState.objData.status === ClubRegistrationConstants.IN_PROGRESS_STATUS ||
        clubRegistrationState.objData.status === ClubRegistrationConstants.RENEWING_STATUS ?
        <div className="row usas-extra-top-margin">
          <div className="col-xs-12">
            <PrimaryButton type="button" onClick={(e) => { onDownloadTemplateClicked(e, STRATEGIC); }}>Download Template</PrimaryButton>&nbsp;
            {fileState.strategicPlanFileUrl === '' ?
              <Fragment>
                <label htmlFor="strategic-plan-file-upload" className={global.FileUpload}>
                  Upload File
                </label>
                {/* <input hidden id="strategic-plan-file-upload" type="file" onChange={onUploadStrategicPlanClicked} /> */}
                <input hidden id="strategic-plan-file-upload" type="file" onChange={(e) => onUploadDocumentClicked(e, STRATEGIC_PLAN)} />
                &nbsp;(*.pdf), (*.doc), or (*.docx)
              </Fragment>
              :
              <Fragment>
                <SecondaryButton onClick={(e) => { onOpenRemoveFileModalClicked(e, STRATEGIC_PLAN_TYPE) }}>
                  {fileState.strategicPlanFileName.includes("Bad Request") ? "Clear Invalid" : "Remove Uploaded"} File
                </SecondaryButton>&nbsp;
                {fileState.strategicPlanFileName.includes("Bad Request") === false &&
                  <PrimaryButton type="button" onClick={(e) => { onDownloadUploadedFile(e, fileState.strategicPlanFileUrl); }}>Download Uploaded File</PrimaryButton>
                }
              </Fragment>}
          </div>
        </div> :
        <Fragment >
          <div className="row usas-extra-bottom-margin" hidden={fileState.strategicPlanFileUrl !== ''}>
            <div className="col-xs-12">
              <p><b>No Uploaded File</b> </p>
            </div>
          </div>
        </Fragment>}
      <div className="row usas-extra-bottom-margin" hidden={fileState.strategicPlanFileUrl === ''}>
        <div className="col-xs-12">
          {fileState.strategicPlanFileName.includes("Bad Request")
            ? <p className={global.ErrorMessage} style={{ fontSize: 16, fontWeight: 'bold' }}>Invalid File Type</p>
            : <p><b>Uploaded File Name:</b> {fileState.strategicPlanFileName}</p>
          }
        </div>
      </div>

      <div className="row usas-extra-top-margin">
        <div className="col-xs-12">
          <Headings.H6>{HEAD_COACH_RESUME}</Headings.H6>
        </div>
      </div>
      {clubRegistrationState.objData.status === ClubRegistrationConstants.IN_PROGRESS_STATUS ||
        clubRegistrationState.objData.status === ClubRegistrationConstants.RENEWING_STATUS ?
        <div className="row usas-extra-top-margin">
          <div className="col-xs-12">
            {/* <PrimaryButton type="button" onClick={(e) => { onDownloadTemplateClicked(e, RESUME); }}>Download Template</PrimaryButton>&nbsp; */}
            {fileState.headCoachResumeFileUrl === '' ?
              <Fragment>
                <label htmlFor="head-coach-resume-file-upload" className={global.FileUpload}>
                  Upload File
                </label>
                {/* <input hidden id="head-coach-resume-file-upload" type="file" onChange={onUploadHeadCoachResumeClicked} /> */}
                <input hidden id="head-coach-resume-file-upload" type="file" onChange={(e) => onUploadDocumentClicked(e, HEAD_COACH_RESUME)} />
                &nbsp;(*.pdf), (*.doc), or (*.docx)
              </Fragment>
              :
              <Fragment>
                <SecondaryButton onClick={(e) => { onOpenRemoveFileModalClicked(e, HEAD_COACH_RESUME_TYPE) }}>
                  {fileState.headCoachResumeFileName.includes("Bad Request") ? "Clear Invalid" : "Remove Uploaded"} File
                </SecondaryButton>&nbsp;
                {fileState.headCoachResumeFileName.includes("Bad Request") === false &&
                  <PrimaryButton type="button" onClick={(e) => { onDownloadUploadedFile(e, fileState.headCoachResumeFileUrl); }}>Download Uploaded File</PrimaryButton>
                }
              </Fragment>}
          </div>
        </div> :
        <Fragment >
          <div className="row usas-extra-bottom-margin" hidden={fileState.headCoachResumeFileUrl !== ''}>
            <div className="col-xs-12">
              <p><b>No Uploaded File</b> </p>
            </div>
          </div>
        </Fragment>}
      <div className="row usas-extra-bottom-margin" hidden={fileState.headCoachResumeFileUrl === ''}>
        <div className="col-xs-12">
          {fileState.headCoachResumeFileName.includes("Bad Request")
            ? <p className={global.ErrorMessage} style={{ fontSize: 16, fontWeight: 'bold' }}>Invalid File Type</p>
            : <p><b>Uploaded File Name:</b> {fileState.headCoachResumeFileName}</p>
          }
        </div>
      </div>

      <div className="row usas-extra-top-margin">
        <div className="col-xs-12">
          <Headings.H6>{OWNER_BOARD_EXPERIENCE_RESUME_TITLE}</Headings.H6>
        </div>
      </div>
      {clubRegistrationState.objData.status === ClubRegistrationConstants.IN_PROGRESS_STATUS ||
        clubRegistrationState.objData.status === ClubRegistrationConstants.RENEWING_STATUS ?
        <div className="row usas-extra-top-margin">
          <div className="col-xs-12">
            {/* <PrimaryButton type="button" onClick={(e) => { onDownloadTemplateClicked(e, BOARD); }}>Download Template</PrimaryButton>&nbsp; */}
            {fileState.ownerBoardExperienceResumeFileUrl === '' ?
              <Fragment>
                <label htmlFor="owner-board-experience-resume-file-upload" className={global.FileUpload}>
                  Upload File
                </label>
                {/* <input hidden id="owner-board-experience-resume-file-upload" type="file" onChange={onUploadOwnerBoardExperienceResumeClicked} /> */}
                <input hidden id="owner-board-experience-resume-file-upload" type="file" onChange={(e) => onUploadDocumentClicked(e, OWNER_BOARD_EXPERIENCE_RESUME)} />
                &nbsp;(*.pdf), (*.doc), or (*.docx)
              </Fragment>
              :
              <Fragment>
                <SecondaryButton onClick={(e) => { onOpenRemoveFileModalClicked(e, OWNER_BOARD_EXPERIENCE_RESUME_TYPE) }}>
                  {fileState.ownerBoardExperienceResumeFileName.includes("Bad Request") ? "Clear Invalid" : "Remove Uploaded"} File
                </SecondaryButton>&nbsp;
                {fileState.ownerBoardExperienceResumeFileName.includes("Bad Request") === false &&
                  <PrimaryButton type="button" onClick={(e) => { onDownloadUploadedFile(e, fileState.ownerBoardExperienceResumeFileUrl); }}>Download Uploaded File</PrimaryButton>
                }
              </Fragment>}
          </div>
        </div> :
        <Fragment >
          <div className="row usas-extra-bottom-margin" hidden={fileState.ownerBoardExperienceResumeFileUrl !== ''}>
            <div className="col-xs-12">
              <p><b>No Uploaded File</b> </p>
            </div>
          </div>
        </Fragment>}
      <div className="row usas-extra-bottom-margin" hidden={fileState.ownerBoardExperienceResumeFileUrl === ''}>
        <div className="col-xs-12">
          {fileState.ownerBoardExperienceResumeFileName.includes("Bad Request")
            ? <p className={global.ErrorMessage} style={{ fontSize: 16, fontWeight: 'bold' }}>Invalid File Type</p>
            : <p><b>Uploaded File Name:</b> {fileState.ownerBoardExperienceResumeFileName}</p>
          }
        </div>
      </div>

      <div className="row usas-extra-top-margin">
        <div className="col-xs-12">
          <Headings.H6>{BUDGET_OR_BUSINESS_PLAN_TITLE}</Headings.H6>
        </div>
      </div>
      {clubRegistrationState.objData.status === ClubRegistrationConstants.IN_PROGRESS_STATUS ||
        clubRegistrationState.objData.status === ClubRegistrationConstants.RENEWING_STATUS ?
        <div className="row usas-extra-top-margin">
          <div className="col-xs-12">
            {/* <PrimaryButton type="button" onClick={(e) => { onDownloadTemplateClicked(e, BUDGET); }}>Download Template</PrimaryButton>&nbsp; */}
            {fileState.budgetFileUrl === '' ?
              <Fragment>
                <label htmlFor="budget-file-upload" className={global.FileUpload}>
                  Upload File
                </label>
                {/* <input hidden id="budget-file-upload" type="file" onChange={(e) => onUploadBudgetClicked(e)} /> */}
                <input hidden id="budget-file-upload" type="file" onChange={(e) => onUploadDocumentClicked(e, BUDGET_OR_BUSINESS_PLAN)} />
                &nbsp;(*.pdf), (*.doc), (*.docx) or (*.xlsx)
              </Fragment>
              :
              <Fragment>
                <SecondaryButton onClick={(e) => { onOpenRemoveFileModalClicked(e, BUDGET_OR_BUSINESS_PLAN_TYPE) }}>
                  {fileState.budgetFileName.includes("Bad Request") ? "Clear Invalid" : "Remove Uploaded"} File
                </SecondaryButton>&nbsp;
                {fileState.budgetFileName.includes("Bad Request") === false &&
                  <PrimaryButton
                    type="button"
                    onClick={(e) => { onDownloadUploadedFile(e, fileState.budgetFileUrl) }}>Download Uploaded File</PrimaryButton>
                }
              </Fragment>}
          </div>
        </div> :
        <Fragment >
          <div className="row usas-extra-bottom-margin" hidden={fileState.budgetFileUrl !== ''}>
            <div className="col-xs-12">
              <p><b>No Uploaded File</b> </p>
            </div>
          </div>
        </Fragment>}
      <div className="row usas-extra-bottom-margin" hidden={fileState.budgetFileUrl === ''}>
        <div className="col-xs-12">
          {fileState.budgetFileName.includes("Bad Request")
            ? <p className={global.ErrorMessage} style={{ fontSize: 16, fontWeight: 'bold' }}>Invalid File Type</p>
            : <p><b>Uploaded File Name:</b> {fileState.budgetFileName}</p>
          }
        </div>
      </div>

      <div className="row usas-extra-top-margin">
        <div className="col-xs-12">
          <Headings.H6>{HANDBOOK_TITLE}</Headings.H6>
        </div>
      </div>
      {clubRegistrationState.objData.status === ClubRegistrationConstants.IN_PROGRESS_STATUS ||
        clubRegistrationState.objData.status === ClubRegistrationConstants.RENEWING_STATUS ?
        <div className="row usas-extra-top-margin">
          <div className="col-xs-12">
            {/* <PrimaryButton type="button" onClick={(e) => { onDownloadTemplateClicked(e, BUDGET); }}>Download Template</PrimaryButton>&nbsp; */}
            {fileState.handbookFileUrl === '' ?
              <Fragment>
                <label htmlFor="budget-file-upload" className={global.FileUpload}>
                  Upload File
                </label>
                {/* <input hidden id="budget-file-upload" type="file" onChange={(e) => onUploadBudgetClicked(e)} /> */}
                <input hidden id="budget-file-upload" type="file" onChange={(e) => onUploadDocumentClicked(e, HANDBOOK_FILE)} />
                &nbsp;(*.pdf), (*.doc), or (*.docx)
              </Fragment>
              :
              <Fragment>
                <SecondaryButton onClick={(e) => { onOpenRemoveFileModalClicked(e, HANDBOOK_FILE_TYPE) }}>
                  {fileState.handbookFileName.includes("Bad Request") ? "Clear Invalid" : "Remove Uploaded"} File
                </SecondaryButton>&nbsp;
                {fileState.handbookFileName.includes("Bad Request") === false &&
                  <PrimaryButton
                    type="button"
                    onClick={(e) => { onDownloadUploadedFile(e, fileState.handbookFileUrl) }}>Download Uploaded File</PrimaryButton>
                }
              </Fragment>}
          </div>
        </div> :
        <Fragment >
          <div className="row usas-extra-bottom-margin" hidden={fileState.handbookFileUrl !== ''}>
            <div className="col-xs-12">
              <p><b>No Uploaded File</b> </p>
            </div>
          </div>
        </Fragment>}
      <div className="row usas-extra-bottom-margin" hidden={fileState.handbookFileUrl === ''}>
        <div className="col-xs-12">
          {fileState.handbookFileName.includes("Bad Request")
            ? <p className={global.ErrorMessage} style={{ fontSize: 16, fontWeight: 'bold' }}>Invalid File Type</p>
            : <p><b>Uploaded File Name:</b> {fileState.handbookFileName}</p>
          }
        </div>
      </div>

      {((clubRegistrationState.objData.status === ClubRegistrationConstants.IN_PROGRESS_STATUS ||
        clubRegistrationState.objData.status === ClubRegistrationConstants.RENEWING_STATUS) && state.error) ?
        <div className="row">
          <div className="col-xs-12">
            <p className={global.ErrorMessage}>{state.error ? state.error : ''}</p>
          </div>
        </div> : <Fragment />}
      <div className="row usas-extra-top-margin usas-extra-bottom-margin">
        <div className="col-xs-12 usas-extra-top-margin">
          <PrimaryButton type="button" onClick={() => onContinueClicked()}>Continue</PrimaryButton>&nbsp;
          <PrimaryButton type="button" onClick={() => onSaveAndExitClicked()}>
            {clubRegistrationState.objData.status === ClubRegistrationConstants.IN_PROGRESS_STATUS
              || clubRegistrationState.objData.status === ClubRegistrationConstants.RENEWING_STATUS ?
              ClubRegistrationConstants.SAVE_AND_EXIT : ClubRegistrationConstants.EXIT}</PrimaryButton>&nbsp;
          <SecondaryButton type="button" onClick={() => onBackClicked()}>Back</SecondaryButton>
        </div>
      </div>
      <ValidationPopUpModal
        clubRegistrationState={clubRegistrationState}
        state={state}
        modalState={modalState}
        onModalContinue={onModalContinue}
        onModalCanceled={onModalCanceled}
      />
      <PopUpModal
        widthPct={50}
        maxWidth={250}
        title={Constants.LOADING_MSG}
        displayPopUp={clubRegistrationState.isObjLoading} />
      <PopUpModal
        widthPct={50}
        maxWidth={250}
        title={Constants.SAVING_MSG}
        displayPopUp={clubRegistrationState.isSaving || usasClubFileUploadState.isObjLoading} />
      <PopUpModal
        widthPct={90}
        maxWidth={720}
        title={removeFileModalState.modalTitle}
        displayPopUp={removeFileModalState.displayPopUp}
        onModalCanceled={onRemoveFileModalCanceled}>
        <div className="row">
          <div className="col-xs-12">
            <p><b>File Type:</b> {removeFileModalState.fileType}</p>
            {removeFileModalState.fileName.includes("Bad Request")
              ? <p className={global.ErrorMessage} style={{ fontSize: 16, fontWeight: 'bold' }}>Invalid File Type</p>
              : <p><b>Uploaded File Name:</b> {removeFileModalState.fileName}</p>
            }
          </div>
        </div>
        <div className="row usas-extra-top-margin">
          <div className="col-xs-12">
            <PrimaryButton type="button" onClick={(e) => onRemoveDocumentClicked(e, removeFileModalState.fileType)}>Yes, Remove</PrimaryButton>&nbsp;
            <SecondaryButton type="button" onClick={onRemoveFileModalCanceled}>Cancel</SecondaryButton>
          </div>
        </div>
      </PopUpModal>
    </LeftNav >
  )
}

export default ClubRegistrationMissionStatementBudget;